import React from 'react';
import { RouteType } from '@Pages/RetroSynthesis/constants';

import './RsRouteLabel.theme.scss';

const getRouteClassName = (routeType) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return 'rs-route-label__published';
    case RouteType.PREDICTED:
      return 'rs-route-label__predicted';
    case RouteType.CUSTOMIZED:
      return 'rs-route-label__customized';
    default:
      return undefined;
  }
};

const getRouteLabel = (routeType) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return 'Published';
    case RouteType.PREDICTED:
      return 'Predicted';
    case RouteType.CUSTOMIZED:
      return 'Custom';
    default:
      return undefined;
  }
};

function RsRouteLabel({ routeType, routeNo = 0 }) {
  return (
    <div className="rs-route-label">
      <div className={`rs-route-label-border ${getRouteClassName(routeType)}`} />
      <div>
        <p>{getRouteLabel(routeType)}</p>
        <p>Route</p>
        <p className="rs-route-label--number">#{routeNo}</p>
        <p className="rs-route-label--spacer">&nbsp;</p>
      </div>
    </div>
  );
}

export default RsRouteLabel;
